export const NEW_ACTION = 'new-action';
export const ENROLLMENT = 'enrollment';
export const GO_TO = 'goToAction';